import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'

// Dynamic locales import
const messages = {}
const locales = require.context('', true, /[a-z0-9]+\.json$/i)
locales.keys().forEach(key => {
  messages[key.match(/([a-z0-9]+)\./i)[1]] = locales(key)
})

messages['iDebug'] = []

Vue.use(VueI18n)

var locale = Cookies.get('locale', { domain: process.env.DOMAIN }) || 'en'

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js